import { createProvider } from '@nvision/services/data-provider';

import * as api from './api';
import { normalizeQuoteCollaboratorsList } from './normalize';

export const fetchQuoteCollaboratorsList = createProvider(api.fetchQuoteCollaboratorsList)
  .andThen((res) => normalizeQuoteCollaboratorsList(res))
  .andCatch((error) => {
    if (error instanceof Error && error.name === 'AbortError') {
      console.warn('Fetch list aborted');
    } else {
      console.error('Fetch list was failed:', error);
    }
    throw error;
  });
